require('./index.scss')

import PropTypes from 'prop-types'
import { useState } from 'react'
import { Toast as BootstrapToast } from 'react-bootstrap'
import { Transition } from 'react-transition-group'

import { TOAST_TYPES } from '@/constants/notificationTypes'

import Content from './components/Content'
import Icon from './components/Icon'
import VerticalRule from './components/VerticalRule'

const Toast = ({ children, text, type }) => {
  const [isShowing, setIsShowing] = useState(true)

  const handleOnClick = () => setIsShowing(false)

  return (
    <Transition appear in={isShowing} timeout={500}>
      <BootstrapToast onClose={handleOnClick} show={isShowing}>
        <VerticalRule type={type} />
        <Icon type={type} />
        <Content text={text} type={type}>
          {children}
        </Content>
      </BootstrapToast>
    </Transition>
  )
}

export default Toast

Toast.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    TOAST_TYPES.educator_notice,
    TOAST_TYPES.error,
    TOAST_TYPES.notice,
    TOAST_TYPES.success
  ]).isRequired
}
